import React, { useState } from 'react';
import { Check, Loader2 } from 'lucide-react';
import { STRIPE_PRODUCTS } from '../stripe-config';

interface PricingCardProps {
  onSubscribe?: (priceId: string) => Promise<void>;
}

export function PricingCard({ onSubscribe }: PricingCardProps) {
  const [loading, setLoading] = useState<string | null>(null);

  const handleSubscribe = async (priceId: string) => {
    if (!onSubscribe) return;
    
    setLoading(priceId);
    try {
      await onSubscribe(priceId);
    } catch (error) {
      console.error('Subscription error:', error);
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="max-w-md mx-auto">
      {STRIPE_PRODUCTS.map((product) => (
        <div key={product.priceId} className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
          <div className="p-8">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">{product.name}</h3>
              <div className="flex items-baseline justify-center mb-4">
                <span className="text-4xl font-bold text-gray-900">{product.currency}{product.price.toFixed(2)}</span>
                <span className="text-gray-500 ml-2">/mês</span>
              </div>
            </div>

            <p className="text-gray-600 mb-8 leading-relaxed">
              {product.description}
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-center">
                <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" />
                <span className="text-gray-700">Orçamentos ilimitados</span>
              </div>
              <div className="flex items-center">
                <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" />
                <span className="text-gray-700">Cálculo automático de ingredientes</span>
              </div>
              <div className="flex items-center">
                <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" />
                <span className="text-gray-700">Gestão de estoque</span>
              </div>
              <div className="flex items-center">
                <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" />
                <span className="text-gray-700">Relatórios detalhados</span>
              </div>
              <div className="flex items-center">
                <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" />
                <span className="text-gray-700">Suporte prioritário</span>
              </div>
            </div>

            <button
              onClick={() => handleSubscribe(product.priceId)}
              disabled={loading === product.priceId}
              className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-4 px-6 rounded-xl font-semibold text-lg hover:from-blue-700 hover:to-purple-700 transition-all duration-200 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center"
            >
              {loading === product.priceId ? (
                <>
                  <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                  Processando...
                </>
              ) : (
                'Assinar Agora'
              )}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}